import React from 'react'
import { omit } from 'ramda'
import PropTypes from 'prop-types'
import { FormControl, Typography } from '@material-ui/core'

import LabelError from 'app/componentV4/Labels/LabelError'
import Input from './Input'

const SimpleInput = (props) => {
  const { id, value, maxLength = 0, helperText, error, inputProps } = props

  const omitInputProps = omit(
    ['helperText', 'InputLabelProps', 'InputProps'],
    props,
  )

  // Props -> OutlinedInput MUI Doc
  return (
    <FormControl fullWidth>
      <div className="relative">
        <Input
          {...omitInputProps}
          inputProps={{ ...inputProps, 'data-testid': id }}
        />
        {maxLength > 0 && (
          <Typography
            variant="caption"
            className="absolute bottom-0 right-0 px-3 text-grey-200"
          >
            {value.length}/{maxLength}
          </Typography>
        )}
      </div>
      {error && <LabelError id={id} text={helperText} />}
    </FormControl>
  )
}

SimpleInput.propTypes = {
  id: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string,
  maxLength: PropTypes.number,
  helperText: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  inputProps: PropTypes.object,
}

export default SimpleInput
